import PropTypes from "prop-types"

import { statusMeta } from "./meetingUtils"

// An API calendar row as a FullCalendar event. The coloured block itself is
// drawn by MeetingEventContent, so the event box is left transparent.
export function toCalendarEvent(row) {
  const names = (row.candidate_names || []).filter(Boolean).join(", ")
  return {
    id: String(row.id),
    title: [names || row.title, row.host_name].filter(Boolean).join(" · "),
    start: row.start_datetime,
    end: row.end_datetime,
    classNames: ["meeting-event-box"],
    extendedProps: { meetingId: row.id, status: row.display_status },
  }
}

// Same colours as the status chips: blue upcoming, green completed, amber
// rescheduled, red cancelled (struck through).
export function MeetingEventContent({ timeText, title, status }) {
  const { label, chip, calendarColor } = statusMeta(status)
  return (
    <div
      className="meeting-event"
      data-testid="meeting-event"
      title={`${label}: ${title}`}
      style={{
        backgroundColor: chip.background,
        color: chip.text,
        borderLeft: `3px solid ${calendarColor}`,
        textDecoration: status === "cancelled" ? "line-through" : "none",
      }}
    >
      {timeText ? (
        <span className="meeting-event__time">{timeText}</span>
      ) : null}
      <span className="meeting-event__title">{title}</span>
    </div>
  )
}

MeetingEventContent.propTypes = {
  timeText: PropTypes.string,
  title: PropTypes.string.isRequired,
  status: PropTypes.string,
}

export function renderEventContent(arg) {
  return (
    <MeetingEventContent
      timeText={arg.timeText}
      title={arg.event.title}
      status={arg.event.extendedProps.status}
    />
  )
}
